import React from "react"
// Circular deps means we have to access helpers directly
import getMessage from "@irati/utils/lang/helpers/getMessage"
import {getErrorValues} from "@irati/utils/lang/formatError"
import ErrorText from "../ErrorText"
import {ErrorProps} from "."
import {useIntl} from "@irati/utils/lang"

interface Props extends ErrorProps {}

const LoadingError = (props: Props) => {
  const {error, errorMsg} = props
  const {formatMessage} = useIntl()
  return <ErrorText {...props}>{getMessage(formatMessage, errorMsg, getErrorValues(error))}</ErrorText>
}

export default LoadingError
